import notley from './notley.png';
import plants from './plant-top-white-background.png';
import mapPin from './map-pin.png';
import './App.css';

function App() {
  return (
    <div className="app">
      <div className="card">
        <img class="background" id="transparent-plants" src={plants}></img>
        <div id="save-the-date">
          <div id="title-1">
            SAVE
          </div>
          <div id="the">
            the
          </div>
          <div id="title-3">
            DATE
          </div>
        </div>
        <div className="ftwo">for the wedding of</div>
        <div className="names">ABBY &amp; RYAN</div>
        <div className="line"></div> {/* Line element */}
        <div className="date">30th May 2027</div>
        <div className="location">
          <img id="map-pin" src={mapPin}></img>
          <a href="https://maps.app.goo.gl/BjJbu1zLMZZtzvvj8">
          <u>Notley Abbey</u><br />
            <u>Buckinghamshire</u><br />
          </a>
        </div>
        <div className="footer">Formal invitation to follow</div>
        <img src={notley} alt="Notley Abbey" class='background' id="background-image" />
      </div>
    </div>
  );
}

export default App;
